import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-edit-view-button',
  templateUrl: './edit-view-button.component.html',
  styleUrls: ['./edit-view-button.component.scss']
})
export class EditViewButtonComponent {
  @Input() public shouldShowButton!: boolean;
  @Input() public isEdit!: boolean;
  @Input() public isView!: boolean;
  @Output() public buttonClicked = new EventEmitter<void>();
  
  public get buttonIcon(): string {
    return this.isEdit ? 'mode_edit' : this.isView ? 'remove_red_eye' : '';
  }

  public perform(): void {
    this.buttonClicked.emit();
  }
}
